import authConstants from '../actiontypes/auth';
import { refreshToken } from '../../api/AuthService';

function refresh(token) {
  return dispatch => {
    dispatch({ type: authConstants.TOKEN_REFRESH_REQUEST });

    window.sessionStorage.setItem('token', token);

    refreshToken().then(
      response => {
        dispatch({
          type: authConstants.TOKEN_REFRESH_SUCCESS,
          token: response.data.access_token
        });
      },
      () => {
        window.sessionStorage.removeItem('token');
        dispatch({
          type: authConstants.TOKEN_REFRESH_FAILURE
        });
      }
    );
  };
}

function setInitPage(page) {
  return dispatch => {
    dispatch({ type: authConstants.INIT_PAGE_SET, payload: page });
  };
}

const authActions = {
  refresh,
  setInitPage
};

export default authActions;
